"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSizeOptions = exports.calculateMatchedSlugs = void 0;
function calculateMatchedSlugs(sizeSlug, sizeSlugs) {
    const sizeSlugValues = sizeSlugs.values;
    // Ha nincs * karakter, akkor pontos egyezést keresünk.
    if (!sizeSlug.includes('*')) {
        return sizeSlugValues.includes(sizeSlug) ? [sizeSlug] : [];
    }
    // Regex mintát készítünk a * karakterek helyére .*-t rakva.
    const escapedSizeSlug = sizeSlug.replace(/([.?+^$[\]\\(){}|-])/g, "\\$1"); // Speciális karakterek escape-elése.
    const regexPattern = escapedSizeSlug.replace(/\*/g, '.*'); // * -> .*
    const regex = new RegExp(`^${regexPattern}$`);
    // Visszaadjuk az összes sizeSlug-ot, ami illeszkedik a regex mintára.
    return sizeSlugValues.filter(slug => regex.test(slug));
}
exports.calculateMatchedSlugs = calculateMatchedSlugs;
function calculateSizeOptions(sizeSlugs) {
    // Értékek gyűjtése width, profile, diameter szerint.
    const resultMap = {
        widths: new Set(),
        profiles: new Set(),
        diameters: new Set(),
    };
    // Minden sizeSlugból kiszedjük az értékeket, majd hozzáadjuk a megfelelő set-hez.
    sizeSlugs.forEach(sizeSlug => {
        const [width, profile, diameter] = sizeSlug.split('~');
        if (width) {
            resultMap.widths.add(width);
        }
        if (profile) {
            resultMap.profiles.add(profile);
        }
        if (diameter) {
            resultMap.diameters.add(diameter);
        }
    });
    return resultMap;
}
exports.calculateSizeOptions = calculateSizeOptions;
